// src/components/Table/TableCell.tsx

import React from 'react';
import { DataCell, HeaderCell } from './styles';

interface CellProps {
    children: React.ReactNode;
    align?: 'left' | 'center' | 'right';
    width?: string;
    isHeader?: boolean;
}

export const TableCell: React.FC<CellProps> = ({
    children,
    align = 'left',
    width,
    isHeader = false
}) => {
    if (isHeader) {
        return (
            <HeaderCell $width={width} $align={align}>
                {children}
            </HeaderCell>
        );
    }

    return (
        <DataCell $align={align}>
            {children}
        </DataCell>
    );
};